import React from "react";

import { ToggleSwitch } from "shared/ui";

import { useIikoIntegrationContext } from "features/IikoIntegration/context";

import { Card, Dot, Subtitle, Summary, Text, Title, ToggleWrap } from "./styles";

/*
* Состояние подключения одной строкой. Включить интеграцию нельзя, пока мастер не пройден —
* заказам некуда уходить; а вот выключить можно всегда: если у подключённого меню удалить
* последний терминал, включённая интеграция иначе осталась бы запертой.
* */
export const ConnectionStatusCard = () => {
    const state = useIikoIntegrationContext();

    const canToggle = state.isConnected || state.isEnabled;

    return (
        <Card>
            <Summary>
                <Dot $tone={state.statusTone} />
                <Text>
                    <Title>{state.statusTitle}</Title>
                    <Subtitle>{state.statusSubtitle}</Subtitle>
                </Text>
            </Summary>

            <ToggleWrap>
                <ToggleSwitch
                    checked={state.isEnabled}
                    onChange={state.toggleEnabled}
                    label="Интеграция включена"
                    disabled={!canToggle || state.saving.enabled}
                />
            </ToggleWrap>
        </Card>
    );
};
